export const FETCH_CEP_FAIL = 'cep/FETCH_CEP_FAIL';
export const CEP_REQUEST = 'cep/CEP_REQUEST';
export const CEP_SUCCESS = 'cep/CEP_SUCCESS';
export const CEP_RESET_STATE = 'cep/CEP_RESET_STATE';
export const REGISTER_DIRTY_FIELD = 'forms/REGISTER_DIRTY_FIELD';
